// ROUTES
export const selectRouter = (state) => state.router;
export const selectPreviousPath = (state) => selectRouter(state).previousPath;
export const selectRouteLoading = (state) => selectRouter(state).routeLoading;
export const selectShowRouteLoader = (state) => selectRouter(state).showRouteLoader;